import type { SecretSettingStatus as Status } from '../../types/dealerSecretSetting.types';

interface Props {
    status: Status;
}

const NOT_SET = <span className="text-mp-muted">Not set</span>;

const mask = (last4: string | null): string => `••••${last4 ?? ''}`;

export function SecretSettingStatus({ status }: Props) {
    const { own, effective } = status;

    return (
        <table className="w-full text-sm">
            <tbody>
                <tr className="border-b border-mp-border">
                    <th scope="row" className="w-32 px-3 py-2 text-left">Own key</th>
                    <td className="px-3 py-2 text-left">{own.has_value ? mask(own.last4) : NOT_SET}</td>
                </tr>
                <tr className="border-b border-mp-border">
                    <th scope="row" className="px-3 py-2 text-left">Effective</th>
                    <td className="px-3 py-2 text-left">
                        {effective.has_value ? mask(effective.last4) : NOT_SET}
                        {effective.has_value && effective.inherited && (
                            <span className="ml-2 text-sm text-mp-muted">
                                Inherited from {effective.source_dealer_name ?? 'a parent group'}
                            </span>
                        )}
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
